import useUrl from "hooks/useUrl"
import React from "react"

function ProductDetailAttachment(
  {
    attachmentList,
  }: {
    attachmentList: SkuDetail.PageMallSkuDetail["attachmentList"]
  },
  ref,
) {
  const { getPublicUrl } = useUrl()
  return (
    <>
      <div className="content" ref={ref}>
        {attachmentList
          ?.sort((a, b) => a.detailType - b.detailType)
          .map((attachment, idx, arr) => (
            <div key={idx}>
              {attachment.detailTypeName &&
                (idx == 0 ||
                  attachment.detailTypeName !==
                    arr[idx - 1].detailTypeName) && (
                  <div className="contentSectionTitle">
                    <span>{attachment.detailTypeName}</span>
                  </div>
                )}
              {attachment.contentType == 0 && (
                <img src={getPublicUrl(attachment.content)} alt="" />
              )}
              {attachment.contentType == 1 && <pre>{attachment.content}</pre>}
            </div>
          ))}
      </div>
      <style jsx>{`
        .content {
          background-color: #fff;
          padding: 0 25px;
        }

        .content img {
          width: 100%;
        }

        .content pre {
          white-space: pre-wrap;
        }

        .contentSectionTitle {
          text-align: center;
          font-size: 14px;
          color: #666666;
          letter-spacing: 0;
          line-height: 53px;
          height: 53px;
        }

        .contentSectionTitle span {
          position: relative;
        }
        .contentSectionTitle span::before,
        .contentSectionTitle span::after {
          content: "";
          width: 38px;
          height: 1px;
          background: #b4b8b9;
          position: absolute;
          top: 8px;
        }
        .contentSectionTitle span::before {
          left: -44px;
        }
        .contentSectionTitle span::after {
          right: -44px;
        }
      `}</style>
    </>
  )
}

export default React.forwardRef(ProductDetailAttachment)
